import { functions } from "../lib/firebaseApp";
import { httpsCallable } from "firebase/functions";
import { auth } from "../lib/firebaseApp"
import { f_add_user, f_delete_user, f_update_user, f_set_user_claim, f_listAllUser, f_getUserByEmail, f_getUserById } from "./fbFunctions";



/**
 * 
 * @param {string} email         Mandatory
 * @param {string} password      Mandatory
 * @param {string} displayName   
 * @param {boolean} disabled 
 * @param {string} phoneNumber 
 * @param {url} photoURL 
 * @returns 
 */
export const add_user = async (email, password, displayName=undefined, disabled=false, phoneNumber=undefined, photoURL=undefined) => {
    if( email == undefined ){
        throw new Error("missing mandatory EMAIL param")
    }

    if( password == undefined ){
        throw new Error("missing mandatory PASSWORD param")
    }

    let user_data = { 
        email, 
        password, 
        disabled
    }

    if( displayName !== undefined){
        user_data = {...user_data, displayName}
    }

    if( phoneNumber !== undefined){
        user_data = {...user_data, phoneNumber}
    }
    
    if( photoURL !== undefined){
        user_data = {...user_data, photoURL}
    }

    console.log("add_user ", user_data)
    
    const uid = await f_add_user(user_data)
        .then((result) => {
            // Read result of the Cloud Function.
            /** @type {any} */
            const data = result.data;
            return data.uid;
        })
        .catch((error) => {
            // Getting the Error details.
            const code = error.code;
            const message = error.message;
            const details = error.details;
            console.error("Error in add_user cloud function\nError [", code, "]: \n", message, "\n", details)
            return undefined
        });

    return uid
}

/**
 * 
 * @param {*} uid 
 * @returns 
 */
export const delete_user = async (uid) => {
    console.log("delete_user ", uid)
    
    const res = await f_delete_user(uid)
        .then((result) => {
            // Read result of the Cloud Function.
            /** @type {any} */
            const data = result.data;
            return data.done;
        })
        .catch((error) => {
            // Getting the Error details.
            const code = error.code;
            const message = error.message;
            const details = error.details;
            console.error("Error in delete_user cloud function\nError [", code, "]: \n", message, "\n", details)
            return undefined
        });

    return res
}

/**
 * 
 * @param {*} uid 
 * @param {*} user_data 
 * @returns 
 */
export const update_user = async (uid, user_data) => {
    if( uid == undefined ){
        throw new Error("missing mandatory UID param")
    }

    console.log("update_user [", uid, "] ", user_data)
    
    const _uid = await f_update_user({uid, user_data})
        .then((result) => {
            // Read result of the Cloud Function.
            /** @type {any} */
            const data = result.data.userRecord;
            return {uid: uid, user_data: data};
        })
        .catch((error) => {
            // Getting the Error details.
            const code = error.code;
            const message = error.message;
            const details = error.details;
            console.error("Error in update_user cloud function\nError [", code, "]: \n", message, "\n", details)
            return undefined
        });

    return _uid
}



/**
 * 
 * @param {*} uid 
 * @param {*} admin 
 * @param {*} accessLevel 
 * @returns 
 */
export const set_user_claim = async (uid, admin, accessLevel) => {
    if( uid == undefined ){
        throw new Error("missing mandatory UID param")
    }

    if( admin == undefined ){
        throw new Error("missing mandatory ADMIN param")
    }

    if( accessLevel == undefined ){
        throw new Error("missing mandatory ACCESSLEVEL param")
    }

    console.log("set_user_claim [", uid, "] ", admin, ", ", accessLevel)
    
    const _uid = await f_set_user_claim({uid, admin, accessLevel})
        .then((result) => {
            // Read result of the Cloud Function.
            /** @type {any} */
            const data = result.data;
            return data.done;
        })
        .catch((error) => {
            // Getting the Error details.
            const code = error.code;
            const message = error.message;
            const details = error.details;
            console.error("Error in set_user_claim cloud function\nError [", code, "]: \n", message, "\n", details)
            return undefined
        });

    return _uid
}


export const getUserByEmail = async (email) => {
    if( email == undefined ){
        throw new Error("missing mandatory email param")
    }

    console.log("getUserByEmail [", email, "] ")
    
    const uid = await f_getUserByEmail({email})
        .then((result) => {
            // Read result of the Cloud Function.
            /** @type {any} */
            const data = result.data.userRecord;
            return {email: email, user_data: data};
        })
        .catch((error) => {
            // Getting the Error details.
            const code = error.code;
            const message = error.message;
            const details = error.details;
            console.error("Error in getUserByEmail cloud function\nError [", code, "]: \n", message, "\n", details)
            return undefined
        });

    return uid
}


export const getUserById = async (uid) => {
    if( uid == undefined ){
        throw new Error("missing mandatory uid param")
    }

    console.log("getUserByuid [", uid, "] ")
    
    const _uid = await f_getUserById({uid})
        .then((result) => {
            // Read result of the Cloud Function.
            /** @type {any} */
            const data = result.data.userRecord;
            return {uid: uid, user_data: data};
        })
        .catch((error) => {
            // Getting the Error details.
            const code = error.code;
            const message = error.message;
            const details = error.details;
            console.error("Error in getUserByEmail cloud function\nError [", code, "]: \n", message, "\n", details)
            return undefined
        });

    return _uid
}


export const get_user_list = async () => {
    const user_list = await f_listAllUser()
        .then((result) => {
            const {users, pageToken} = result.data;
            console.log("RES", result)
            return users;
        })
        .catch((error) => {
            // Getting the Error details.
            const code = error.code;
            const message = error.message;
            const details = error.details;
            console.error("Error in listAllUser cloud function\nError [", code, "]: \n", message, "\n", details)
            return []
        });

    return user_list
}